<template>
    <div :style="style">
        <slot/>
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {useNuxtApp} from '#app';

const {$breakpoint} = useNuxtApp();

const props = withDefaults(defineProps<{
	enabled?: boolean,

	// The breakpoint at which and higher the content shall be positioned as sticky
	breakpoint?: string,

	// The spacing to the top of the page when being sticky
	offset?: number,

	disabledStyle?: object
}>(), {
	enabled: true,
	breakpoint: 'md',
	offset: 80,
	disabledStyle: {position: 'relative', top: 'unset'} // Unset required to reset 'top' offset on SSR to CSR hydration
});

const style = computed(() => {
	if (props.enabled && (!props.breakpoint || $breakpoint.isSameOrUp(props.breakpoint))) {
		const scrollbarWidth = 16;
		// maxHeight and overflow required to scroll within container when it's overflowing the screen
		// padding and margin used to compensate overflow and to display potential scrollbar next to content
		return {position: 'sticky', top: `${props.offset}px`, maxHeight: `calc(100vh - ${props.offset}px)`, overflowY: 'auto', padding: `0 ${scrollbarWidth}px`, margin: `0 -${scrollbarWidth}px`};
	}

	return props.disabledStyle
});

</script>